"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelCreateResult = exports.ChannelUpsertResult = exports.TriggerEvent = exports.TriggerType = exports.Scope = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const field_1 = require("../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Shared.Notification';
exports.Scope = effect_1.Schema.Literal('device', 'model', 'tenant', 'all').annotations({
    identifier: `${exports.NAMESPACE}.Scope`,
});
exports.TriggerType = effect_1.Schema.Literal('registry', 'connection', 'property', 'alarm', 'error', 'event').annotations({
    identifier: `${exports.NAMESPACE}.TriggerType`,
});
exports.TriggerEvent = effect_1.Schema.Literal('on_new_datapoint', 'on_value_change', 'on_value_compare', 'on_value_change_compare').annotations({
    identifier: `${exports.NAMESPACE}.TriggerEvent`,
    description: 'Required. When triggerType is event, alarm or error, runtime accepts only on_new_datapoint',
});
exports.ChannelUpsertResult = effect_1.Schema.Struct({
    channelId: (0, field_1.nonEmpty)('Created or updated channel id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelUpsertResult`,
});
exports.ChannelCreateResult = effect_1.Schema.Struct({
    channelId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Id of the new channel. Not returned today: the id generated by the database is not read back',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ChannelCreateResult`,
    description: 'Empty today. The id of the new channel can be read from the channel list',
});
//# sourceMappingURL=notification.js.map